export default "__VITE_PUBLIC_ASSET__7510ac9f__"